<div
  data-cy="inventory-add-items-manually-section"
  class="inventory-add-items-manually"
>
  <p
    data-cy="inventory-add-items-manually-title"
    class="inventory-add-items-manually-title"
  >
    {{ 'i18n.inventory.manualDescription' | translate }}
  </p>
</div>
